<template>
  <span>
    <a
      class="customer-contact-item"
      data-toggle="modal"
      data-target="#popupi"
      @click="SendEmail"
      v-if="!can_view_all_options"
    >
      <div class="btn-group pair_btn_new_uniq">
        <div class="d-inline clickable">
          <svg
            width="24"
            height="24"
            viewBox="0 3 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_5090_38698)">
              <path
                d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z"
                fill="#2E4051"
              />
            </g>
            <defs>
              <clipPath id="clip0_5090_38698">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
    </a>

    <a class="customer-contact-item" v-if="can_view_all_options">
      <div class="btn-group pair_btn_new_uniq">
        <div
          class="d-inline clickable"
          data-toggle="dropdown"
          data-too="tooltip"
          data-placement="bottom"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 3 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_5090_38698)">
              <path
                d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z"
                fill="#2E4051"
              />
            </g>
            <defs>
              <clipPath id="clip0_5090_38698">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>

        <ul
          class="dropdown-menu pair_of_all_li w_und_767 mobile-right-8 ul-position"
          id="pair_of_all_li"
        >
          <li>
            <a
              href="#"
              data-toggle="modal"
              data-target="#popupi"
              @click="SendEmail"
              class="details_info_opt"
            >
              <span></span>
              <span>Send Email</span>
            </a>
          </li>
          <li v-if="hasEstimate && hasEstimate != 0 && estimateId">
            <a
              href="#"
              data-toggle="modal"
              data-target="#popupi"
              @click="EmailQoute"
              class="details_info_opt"
            >
              <span></span>
              <span>Email Quote</span>
            </a>
          </li>
          <li
            v-if="
              !estimateId && (inquiryHasBooking == 1 || itemType == 'booking')
            "
          >
            <a
              href="#"
              data-toggle="modal"
              data-target="#popupi"
              @click="EmailBookingConfirmation"
              class="details_info_opt"
            >
              <span></span>
              <span>Send Booking Confirmation</span>
            </a>
          </li>
          <li>
            <a
              v-if="hasEstimate && hasEstimate != 0"
              href="#"
              data-toggle="modal"
              data-target="#popupi"
              @click="EmailQuoteReminder"
              class="details_info_opt"
            >
              <span></span>
              <span>Send Quote Reminder</span>
            </a>
            <a
              v-if="
                !estimateId && (inquiryHasBooking == 1 || itemType == 'booking')
              "
              href="#"
              data-toggle="modal"
              data-target="#popupi"
              @click="EmailBookingReminder"
              class="details_info_opt"
            >
              <span></span>
              <span>Send Booking Reminder</span>
            </a>
          </li>
          <li
            v-if="
              !estimateId && (inquiryHasBooking == 1 || itemType == 'booking')
            "
          >
            <a
              href="#"
              data-toggle="modal"
              data-target="#popupi"
              @click="EmailNextServiceReminder"
              class="details_info_opt"
            >
              <span></span>
              <span>Send Next Service Reminder</span>
            </a>
          </li>
          <li
            v-if="
              !estimateId && (inquiryHasBooking == 1 || itemType == 'booking')
            "
            class="divider"
          ></li>
          <li
            v-if="
              !estimateId && (inquiryHasBooking == 1 || itemType == 'booking')
            "
          >
            <a
              href="#"
              data-toggle="modal"
              data-target="#popupi"
              @click="EmailPhotosToCustomer"
              class="details_info_opt"
            >
              <span></span>
              <span>Send Booking Photos</span>
            </a>
          </li>
          <li
            v-if="
              !estimateId && (inquiryHasBooking == 1 || itemType == 'booking')
            "
          >
            <a
              href="#"
              data-toggle="modal"
              data-target="#popupi"
              @click="RequestPhotos"
              class="details_info_opt"
            >
              <span></span>
              <span>Request Photos</span>
            </a>
          </li>
          <li
            v-if="
              !estimateId &&
              (inquiryHasBooking == 1 || itemType == 'booking') &&
              this.invoiceId
            "
            class="divider"
          ></li>
          <li
            v-if="
              !estimateId &&
              (inquiryHasBooking == 1 || itemType == 'booking') &&
              this.invoiceId
            "
          >
            <a
              href="#"
              data-toggle="modal"
              data-target="#popupi"
              @click="SendInvoice"
              class="details_info_opt"
            >
              <span></span>
              <span>Send Invoice</span>
            </a>
          </li>
          <li
            v-if="
              !estimateId &&
              (inquiryHasBooking == 1 || itemType == 'booking') &&
              this.invoiceId
            "
          >
            <a
              href="#"
              data-toggle="modal"
              data-target="#popupi"
              @click="RequestDeposit"
              class="details_info_opt"
            >
              <span></span>
              <span>Request Deposit</span>
            </a>
          </li>
        </ul>
      </div>
    </a>
  </span>
</template>
<script>
export default {
  name: "CustomerSendEmailBtn",
  props: {
    theme: {
      type: String,
      default: "circle",
      required: true,
    },
    email_link: {
      type: String,
      default: "",
      required: true,
    },
    customerId: {
      required: true,
    },
    contactId: {
      default: null,
    },
    invoiceId: {
      required: true,
    },
    hasEstimate: false,
    bookingId: {
      required: true,
    },
    estimateId: {
      required: false,
    },
    bookingInfo: {
      required: true,
    },
    fromBooking: false,
    itemType: {
      type: String,
      default: "customer",
    },
    fromInquiry: false,
    fromQuote: false,
    inquiryHasBooking: 0,
    inquiryBookingId: 0,
  },
  data() {
    return {
      bookingEmailStatus: this.bookingInfo.pause_emails,
      viewBooking: this.fromBooking && this.itemType === "booking",
      can_view_all_options: this.fromBooking || this.fromQuote,
    };
  },
  methods: {
    SendEmail() {
      this.hidePopover();
      window.popupi("Send Email", this.email_link);
    },
    EmailQoute() {
      if (this.hasEstimate) {
        window.popupi(
          "Email Quote",
          `/get-canned-responses-form/customer/email/estimate/${this.hasEstimate}/${this.customerId}/send_estimate_as_email?secondary_contact=${this.contactId}`
        );
      } else {
        window.popupi(
          "Email Quote",
          `/get-canned-responses-form/customer/email/estimate/${this.estimateId}/${this.customerId}/send_estimate_as_email?secondary_contact=${this.contactId}`
        );
      }
    },
    SendInvoice() {
      window.popupi(
        "Email Invoice",
        `/get-canned-responses-form/customer/email/invoice/${this.invoiceId}/${this.customerId}/send_invoice_as_email?secondary_contact=${this.contactId}`
      );
    },
    RequestDeposit() {
      window.popupi(
        "Request Deposit",
        `/get-canned-responses-form/customer/email/invoice/${this.invoiceId}/${this.customerId}/send_booking_deposit_as_email?secondary_contact=${this.contactId}`
      );
    },
    RequestPhotos() {
      if (this.itemType == "inquiry") {
        window.popupi(
          "Request Photos",
          `/get-canned-responses-form/customer/email/booking/${this.inquiryBookingId}/${this.customerId}/photo_request?secondary_contact=${this.contactId}`
        );
      } else {
        window.popupi(
          "Request Photos",
          `/get-canned-responses-form/customer/email/invoice/${this.invoiceId}/${this.customerId}/photo_request?secondary_contact=${this.contactId}`
        );
      }
    },
    EmailNextServiceReminder() {
      if (this.itemType == "inquiry") {
        window.popupi(
          "Email Invoice",
          `/get-canned-responses-form/customer/email/booking/${this.inquiryBookingId}/${this.customerId}/reminder_customer_next_service_date?secondary_contact=${this.contactId}`
        );
      } else {
        window.popupi(
          "Email Invoice",
          `/get-canned-responses-form/customer/email/booking/${this.bookingId}/${this.customerId}/reminder_customer_next_service_date?secondary_contact=${this.contactId}`
        );
      }
    },
    EmailBookingConfirmation() {
      if (this.itemType == "inquiry") {
        window.popupi(
          "Booking Confirmation",
          `/get-canned-responses-form/customer/email/booking/${this.inquiryBookingId}/${this.customerId}/send_booking_as_email?secondary_contact=${this.contactId}`
        );
      } else {
        window.popupi(
          "Booking Confirmation",
          `/get-canned-responses-form/customer/email/booking/${this.bookingId}/${this.customerId}/send_booking_as_email?secondary_contact=${this.contactId}`
        );
      }
    },
    EmailBookingReminder() {
      if (this.itemType == "inquiry") {
        window.popupi(
          "Booking Reminder",
          `/get-canned-responses-form/customer/email/booking/${this.inquiryBookingId}/${this.customerId}/booking_reminder?secondary_contact=${this.contactId}`
        );
      } else {
        window.popupi(
          "Booking Reminder",
          `/get-canned-responses-form/customer/email/booking/${this.bookingId}/${this.customerId}/booking_reminder?secondary_contact=${this.contactId}`
        );
      }
    },
    EmailQuoteReminder() {
      if (this.hasEstimate) {
        window.popupi(
          "Quote Reminder",
          `/get-canned-responses-form/customer/email/estimate/${this.hasEstimate}/${this.customerId}/reminder_estimate?secondary_contact=${this.contactId}`
        );
      } else {
        window.popupi(
          "Quote Reminder",
          `/get-canned-responses-form/customer/email/estimate/${this.estimateId}/${this.customerId}/reminder_estimate?secondary_contact=${this.contactId}`
        );
      }
    },
    EmailPhotosToCustomer() {
      if (this.itemType == "inquiry") {
        window.popupi(
          "Send Photos",
          `/get-canned-responses-form/customer/email/booking/${this.inquiryBookingId}/${this.customerId}/send_booking_photos?secondary_contact=${this.contactId}`
        );
      } else {
        window.popupi(
          "Send Photos",
          `/get-canned-responses-form/customer/email/${this.itemType}/${this.bookingId}/${this.customerId}/send_booking_photos?secondary_contact=${this.contactId}`
        );
      }
    },
    hidePopover() {
      // $('.customerPopoverBtn').popover('hide');
      $(".customerPopoverBtn").each(function () {
        var $this = $(this);
        $this.popover("hide");
      });
    },
  },
};
</script>

<style>
.ul-position {
  right: 0;
  left: auto;
}
@media (max-width: 768px) {
  .ul-position {
    right: auto;
    left: auto;
    max-width: 280px !important;
  }
}
</style>
